import React from 'react';
import { useNavigate } from 'react-router-dom';
import type { ButtonProps } from 'antd';
import { useTheme } from '@shared/providers/theme/ThemeContext';
import AppButton from './AppButton';

export type AppBackButtonProps = ButtonProps & {
  label?: React.ReactNode;
  showIcon?: boolean;
};

const AppBackButton = React.forwardRef<HTMLButtonElement, AppBackButtonProps>(
  ({ label = '戻る', showIcon = false, icon, className, style, onClick, ...rest }, ref) => {
    const { colors } = useTheme();
    const navigate = useNavigate();
    const hasIcon = icon ?? (showIcon ? <i className="fa fa-arrow-left" aria-hidden="true" /> : undefined);

    const handleClick = (e: React.MouseEvent<HTMLElement, MouseEvent>) => {
      if (onClick) {
        onClick(e);
      } else {
        navigate(-1);
      }
    };

    return (
      <AppButton
        ref={ref}
        type="default"
        icon={hasIcon}
        className={['px-4 py-2 font-medium border-2 rounded transition-all duration-200', className]
          .filter(Boolean)
          .join(' ')}
        style={{ 
          borderColor: colors.secondary, 
          color: colors.secondary, 
          ...style 
        }}
        onClick={handleClick}
        {...rest}
      >
        {label}
      </AppButton>
    );
  }
);

AppBackButton.displayName = 'AppBackButton';

export default AppBackButton;
